import React from 'react'
import { browserHistory, Link } from 'react-router'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import { readLocally } from '../../helpers/utility'
import { LOGIN_SUCCESS } from '../../actions/actions'
import { PulseLoader } from 'halogen'
import { LOGIN_REQUEST } from '../../actions/actions'
import backgroundImage from '../../images/background.jpg'
import browser from 'detect-browser'
import Checkbox from 'material-ui/Checkbox'
import Visibility from 'material-ui/svg-icons/action/visibility'
import VisibilityOff from 'material-ui/svg-icons/action/visibility-off'
import {
  Row,
  Col,
  Grid,
  Form,
  Panel,
  Button,
  PanelBody,
  FormGroup,
  InputGroup,
  PanelContainer,
} from '@sketchpixy/rubix'
import * as MabnaButton from '../common/Button/Button'

const styles = {
  formWrapper: {
    padding: 25,
    paddingTop: 0,
    paddingBottom: 0,
    margin: 'auto',
    marginBottom: 25,
    marginTop: 25,
  },
  backgroundCss: {
    background: `url(${backgroundImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundColor: '#E0E0E0',
    backgroundRepeat: 'no-repeat',
  },
}

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      passwordInputHidden: true,
      isBrowserOutdated: false,
      warningMessage: '',
    }
  }

  componentWillMount() {
    const prevAuth = readLocally('fpAuth')

    if (prevAuth) {
      const AuthInfo = JSON.parse(prevAuth)

      this.props.dispatch({
        type: LOGIN_SUCCESS,
        userType: AuthInfo.userType,
        token: AuthInfo.token,
        userId: AuthInfo.userId,
      })
    }
  }

  componentDidMount() {
    this.detectBrowser()
  }

  usernameInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="username">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-user-circle-o" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام کاربری (کد ملی برای ورود دانش آموزان)"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  passwordInput = ({ input, meta: { touched, error }, hidden }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="password">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <i className="fa fa-key" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type={hidden ? 'password' : 'text'}
            className="border-focus-blue"
            placeholder="گذرواژه"
            {...input}
          />
          <InputGroup.Addon>
            <Checkbox
              checkedIcon={<Visibility />}
              uncheckedIcon={<VisibilityOff style={{ fill: '#A0A0A0' }} />}
              onCheck={this.onPassShowToggle}
            />
          </InputGroup.Addon>
        </InputGroup>
      </FormGroup>
    )
  }

  onSubmit = values => {
    const { dispatch } = this.props
    return new Promise((resolve, reject) => {
      dispatch({ type: LOGIN_REQUEST, ...values, resolve, reject })
    }).catch(error => {
      // NOTE: all login errors come in general property
      // error.general_errors is an array
      throw new SubmissionError({ _error: error.general_errors[0] })
    })
  }

  onPassShowToggle = () => {
    this.setState({ passwordInputHidden: !this.state.passwordInputHidden })
  }

  detectBrowser = () => {
    const outdatedMessage = `مرورگر شما قدیمی است لطفا برای استفاده از
                                  خدمات سامانه مرورگر خود را بروز کنید.`
    if (!browser) return
    const { name, version } = browser
    const versionNum = parseFloat(version)

    if (name === 'chrome') {
      if (versionNum < 50)
        this.setState({
          warningMessage: outdatedMessage,
          isBrowserOutdated: true,
        })

      return
    }

    if (name === 'firefox') {
      if (versionNum < 50)
        this.setState({
          warningMessage: outdatedMessage,
          isBrowserOutdated: true,
        })

      return
    }

    if (name === 'ie') {
      this.setState({
        warningMessage:
          'مرورگر شما پشتیبانی نمی شود. لطفا از نسخه به روز مرورگر گوگل کروم استفاده کنید.',
        isBrowserOutdated: true,
      })

      return
    }

    // if it's not chrome, firefox or ie, warn them
    this.setState({
      warningMessage:
        'برای استفاده از امکانات این سامانه ترجیحا از نسخه به روز مرورگر گوگل کروم استفاده نمایید در غیر این صورت برخی امکانات برای شما فعال نخواهد بود. ',
      isBrowserOutdated: true,
    })
  }

  render() {
    const { handleSubmit, error } = this.props

    const Heading = () => (
      <div className="text-center bg-darkblue fg-white" style={{ padding: 10 }}>
        <h2 style={{ margin: 0, padding: 10 }}>سامانه مبنا</h2>
        <p
          style={{
            margin: 0,
            padding: 10,
            fontSize: '1.2em',
          }}
        >
          مرکز برنامه ریزی و نوآوری آموزشی موسسه فرهنگی فاطمی
        </p>
      </div>
    )

    return (
      <div id="auth-container" className="login ltr" style={styles.backgroundCss}>
        <div id="auth-row">
          <div id="auth-cell">
            <Grid>
              <Row>
                <Col sm={4} smOffset={4} xs={10} xsOffset={1} collapseLeft collapseRight>
                  <PanelContainer controls={false} id="login-panel">
                    <Panel>
                      <PanelBody style={{ padding: 0 }}>
                        <Heading />

                        <div>
                          <div style={styles.formWrapper}>
                            <Form onSubmit={handleSubmit(this.onSubmit)}>
                              {this.state.isBrowserOutdated && (
                                <div id="out-dated-browser-warning">
                                  {this.state.warningMessage}
                                </div>
                              )}

                              <Field name="username" component={this.usernameInput} />

                              <Field
                                name="password"
                                hidden={this.state.passwordInputHidden}
                                component={this.passwordInput}
                              />

                              <FormGroup>
                                <Row>
                                  <Col
                                    xs={12}
                                    collapseLeft
                                    collapseRight
                                    style={{ paddingLeft: 25 }}
                                  >
                                    <Link to="signup/reset-password">
                                      بازیابی گذرواژه
                                    </Link>
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    textAlign: 'center',
                                    padding: '5px',
                                  }}
                                >
                                  {error && (
                                    <strong className="form-error">{error}</strong>
                                  )}
                                </Row>
                              </FormGroup>

                              <Row className="flex-container">
                                <div className="auth-buttons-container">
                                  {!this.props.aSyncCall ? (
                                    <MabnaButton.Primary
                                      // lg
                                      block
                                      type="submit"
                                      // bsStyle="primary"
                                      className="auth-buttons"
                                    >
                                      ورود
                                    </MabnaButton.Primary>
                                  ) : (
                                    <div
                                      style={{
                                        height: 45,
                                        display: 'flex',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <PulseLoader color="#275C8A" size="10px" />
                                    </div>
                                  )}
                                </div>
                              </Row>

                              <Row className="flex-container">
                                <div className="auth-buttons-container">
                                  <MabnaButton.Primary
                                    outline
                                    // lg
                                    block
                                    // bsStyle="primary"
                                    className="auth-buttons"
                                    onClick={() => browserHistory.push('/signup')}
                                  >
                                    تا کنون عضو سامانه نشده ام
                                  </MabnaButton.Primary>
                                </div>
                              </Row>
                            </Form>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>
                  </PanelContainer>
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    aSyncCall: state.auth.aSyncCall,
  }
}

const validate = values => {
  let errors = {}

  if (!values.username) {
    errors.username = 'نام کاربری خود را وارد کنید'
  }

  if (!values.password) {
    errors.password = 'گذرواژه خود را وارد کنید'
  }

  return errors
}

Login = reduxForm({
  form: 'login',
  validate,
  fields: ['username', 'password'],
})(Login)

export default connect(mapStateToProps)(Login)



// WEBPACK FOOTER //
// ./src/components/authentication/Login.js